import { Col, Divider, Row } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import DeliveryPrice from 'app/components/Core/DeliveryItem/Price'
import LineItemTotalCost from 'app/components/Core/LineItem/Price/Total'
import KSingleCollapse from 'app/components/UI-Elements/DataDisplay/KSingleCollapse'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React, { Fragment } from 'react'

const DeliveryPrices: React.FC<CollectionProps<IDeliveryItem>> = ({ collection = [] }) => {
  const { tRecordType } = ToolBox.useString()

  return (
    <KSingleCollapse
      headerCollapsed={
        <h6 className="text-black mb-0">
          <TotalCosts collection={collection} />
        </h6>
      }
      header={
        <h6 className="text-black mb-0">{tRecordType(RecordType.delivery_item, 'list_title')}</h6>
      }>
      <Row>
        <Col span={24}>
          {collection.map((deliveryItem, index) => (
            <Fragment key={`${deliveryItem.name}-${index}`}>
              <DeliveryPrice member={deliveryItem} />
              <Divider />
            </Fragment>
          ))}
        </Col>
        <Col span={24}>
          <strong>
            <TotalCosts collection={collection} />
          </strong>
        </Col>
      </Row>
    </KSingleCollapse>
  )
}

function TotalCosts({ collection }: { collection: IDeliveryItem[] }) {
  const { tRecordType } = ToolBox.useString()

  return (
    <LineItemTotalCost
      collection={collection}
      props={{
        memberProps: { name: tRecordType(RecordType.delivery_item, 'total_cost') }
      }}
    />
  )
}

export default DeliveryPrices
